import React from "react";
import type { IconProps } from "./types";

export const InvestorIcon = React.forwardRef<SVGSVGElement, IconProps>(
  function InvestorIcon({ size = 24, width, height, className = "", fill = "currentColor", ...props }, ref) {
    return (
      <svg
        ref={ref}
        width={width || size}
        height={height || size}
        viewBox="0 0 216 256"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path
          d="M213.3,151.6l-19.9-52.4c0,0-2.1-20.8-4-28.8C181.1,34.6,141.1,2,97.7,2C44.9,2.1,2.1,45,2.1,97.8c0,29.3,13.5,57,36.5,75.1
          V254h102v-27.2h15c20.8,0,37.7-16.9,37.7-37.7c0,0,0,0,0,0v-26.8h12.7c4.3,0,7.8-3.5,7.8-7.8c0,0,0,0,0,0
          C213.9,153.5,213.7,152.6,213.3,151.6z M97.3,145.5c-29,0-52.5-23.5-52.5-52.5s23.5-52.5,52.5-52.5S149.7,64,149.8,93c0,0,0,0,0,0
          c0.1,28.9-23.3,52.4-52.2,52.5C97.4,145.5,97.4,145.5,97.3,145.5L97.3,145.5z M102.3,87.9c-7.2-3-10.6-4.3-10.6-8
          c0-2.6,2.9-5.3,8.2-5.3c4,0.1,8,1,11.6,2.6l2.9-10.3c-4.2-2.1-8.9-3.1-13.6-3v-8.2h-7.3v8.7c-9.7,2-15,8.2-15,16.2
          c0,8.7,6,13.5,15.6,16.9c6.9,2.7,9.8,4.2,9.8,7.8s-2.9,6.3-9,6.3c-5-0.1-9.8-1.4-14.2-3.6l-2.6,10.6c3.1,1.7,9.4,3.4,15.6,3.4v8h7.3
          v-8.2c10.6-2.4,15.6-8.6,15.6-16.9S112.2,91.5,102.3,87.9L102.3,87.9z"
          fill={fill}
        />
      </svg>
    );
  }
);
